export default __webpack_public_path__ + "static/media/jonathan-borba-uB7q7aipU2o-unsplash.7b309b0f.jpg";